import axios from '../utils/axios';

export default function fetchLearningSubscriptionCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/learning-subscription-count', { params })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}